import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";

import { authClient } from "@/lib/auth-client";

export function useSignInAnonymously() {
	const router = useRouter();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async () => {
			const response = await authClient.signIn.anonymous();
			if (response?.error) {
				throw new Error(response.error.message ?? "匿名登录失败");
			}
			return response.data;
		},
		onSuccess: async () => {
			queryClient.clear();
			await router.invalidate();
		},
	});
}
